/* eslint-disable */
export default {
  _planet: 'planet',
  _largeLight: 'largeLight',
  _pauseOverlay: 'pauseOverlay',
  _LaserBeam: 'LaserBeam',
  _leftDoor: 'leftDoor',
  _clockBackground: 'clockBackground',
  _Particle0000: 'Particle0000',
  _meter_GreenDot: 'meter_GreenDot',
  _meter_GreenBar: 'meter_GreenBar',
  _meter_RedBar: 'meter_RedBar',
  _star: 'star',
  _city: 'city',
  _backButton: 'backButton',
  _cityBackground: 'cityBackground',
  _menuButton: 'menuButton',
  _menuButton2: 'menuButton2',
  _menuButton2_Depressed: 'menuButton2_Depressed',
  _rocketFlame_Vertical: 'rocketFlame_Vertical',
  _playButton: 'playButton',
  _meter_RedDot: 'meter_RedDot',
  _diamond: 'diamond',
  _muteButton: 'muteButton',
  _laserRay: 'laserRay',
  _BonusShip: 'BonusShip',
  _rocketFlame_Horizontal: 'rocketFlame_Horizontal',
  _instructionsFlame: 'instructionsFlame',
  _brokenRock3: 'brokenRock3',
  _Particle0001: 'Particle0001',
  _Particle0002: 'Particle0002',
  _Particle0004: 'Particle0004',
  _Particle0003: 'Particle0003',
  _pauseButton: 'pauseButton',
  _rocket: 'rocket',
  _rocketShadow: 'rocketShadow',
  _cloud: 'cloud',
  _brokenRock1: 'brokenRock1',
  _brokenRock2: 'brokenRock2',
  _brokenRock4: 'brokenRock4',
  _soundButton: 'soundButton',
  _menuButton_Depressed: 'menuButton_Depressed',
  _meter_Rocket: 'meter_Rocket',
  _blankSpace: 'blankSpace',
  _spaceRock: 'spaceRock',
  _meter_Star: 'meter_Star',
  _brokenRock5: 'brokenRock5',
  _LaserRayGlow: 'LaserRayGlow',
  _smallLight: 'smallLight',
  _muteButton_Depressed: 'muteButton_Depressed',
  _soundButton_Depressed: 'soundButton_Depressed',
  _starBase: 'starBase',
  _bg1: 'bg1',
  _rightDoor: 'rightDoor',
  _bg2: 'bg2',
  _Subtitle_Fives: 'Subtitle-Fives',
  _Subtitle_Ones: 'Subtitle-Ones',
  _Subtitle_Tens: 'Subtitle-Tens',
  _Subtitle_Threes: 'Subtitle-Threes',
  _Subtitle_Twos: 'Subtitle-Twos',
  _instructionsBackground: 'instructionsBackground',
  _plainPlayButton: 'plainPlayButton',
  _starBase_Depressed: 'starBase_Depressed',
  _bg3: 'bg3',
  _bonusBackground: 'bonusBackground',
}